<template>
	<div>
		<myheader headTitle="签署详情"></myheader>
		<div class="all_main" style="padding-bottom: 3.4rem;">
			<div class="all_content_padding" v-if="quickSignInfo">
				<div class="all_details_content_card">
					<div class="text16 textcolor333 font_weight_700" style="width: 85%;">
						{{quickSignInfo.contractName}}
					</div>
					<div class="margin_top_1 margin_bottom_3">
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">发起方：</span>
							<span class="text12 textcolor999">
								{{quickSignInfo.corpName}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">发起日期：</span>
							<span class="text12 textcolor999">
								{{quickSignInfo.createdTime?Tool.dateFormate(quickSignInfo.createdTime):'-'}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">截止日期：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.expireDate?Tool.dateFormate(quickSignInfo.expireDate):'-'}}</span>
						</div>
						<div class="margin_top_1" v-if="quickSignInfo.contractStatus===1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">完成日期：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.completeTime?Tool.dateFormate(quickSignInfo.completeTime):'-'}}</span>
						</div>
						<div class="margin_top_1" v-if="quickSignInfo.contractStatus===2">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">取消日期：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.cancelTime?Tool.dateFormate(quickSignInfo.cancelTime):'-'}}</span>
						</div>
					</div>
					<div class="text12 textcolorwhite all_text_center"
						style="position: absolute;right: .5rem; top: .5rem;padding: .1rem .3rem;border-radius: 0.1rem;"
						:class="{sign_status_ing:quickSignInfo.contractStatus===0,
						sign_status_ed:quickSignInfo.contractStatus===1,sign_status_can:quickSignInfo.contractStatus===2}">
						{{quickSignInfo.contractStatus===0?'签署中':(quickSignInfo.contractStatus===1?'已完成':'已取消')}}
					</div>
					<!-- <div v-show="!contractHidden">
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">文件编号：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.contractCode?quickSignInfo.contractCode:'-'}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">上链时间：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.evidenceTime?Tool.dateFormate(quickSignInfo.evidenceTime):'-'}}</span>
						</div>
						<div class="margin_top_1">
							<span class="text12 textcolor999" style="display: inline-block; width: 20%;">存证编号：</span>
							<span class="text12 textcolor999" style="word-break: break-all;">
								{{quickSignInfo.evidenceCode?quickSignInfo.evidenceCode:'-'}}</span>
						</div>
					</div>
					<div class="horizontal_line margin_top_5"></div>
					<div class="all_text_center" style="margin: .3rem 0 -.5rem;"
						@click="contractHidden = !contractHidden">
						<img src="@/assets/images/down_display.svg" :class="{rotate:!contractHidden}">
					</div> -->
				</div>
				<div class="text12 textcoloblack font_weight_700 margin_top_5" style="margin-left: .5rem;">
					{{'签约信息 （'+quickSignInfo.signers.length+'）'}}
				</div>
				<div class="all_details_content_card margin_top_2">
					<div class="corps" v-for="(item,index) in quickSignInfo.signers" :key="index">
						<div class="text12 textcolorblack font_weight_700">{{item.corpAlias||item.corpName||'-'}}
						</div>
						<div class="horizontal_line margin_top_3"></div>
						<div class="margin_top_3" style="display: flex;">
							<span class="all_height_line14 text12 textcolor999 display_inline_block"
								style="width:55%;overflow: hidden;">{{'签名人: '+(item.signerName||'-')}}</span>
							<span v-if="item.actStatus === 0"
								class="all_height_line14 text12 textcolor333 display_inline_block"
								style="width: 20%; margin-left: 25%;">{{item.actStatusText}}</span>
							<span v-else class="display_flex display_inline_block" style="width: 45%;">
								<span class="all_height_line14 text12 textcolor333 display_inline_block"
									style="width:80%">{{Tool.dateFormate(item.signTime)}}</span>
								<img src="@/assets/images/selected.svg"
									style="width: .7rem; height: .7rem;margin-top: .3rem;" />
							</span>
						</div>
					</div>
				</div>
				<div class="text12 textcoloblack font_weight_700 margin_top_5" style="margin-left: .5rem;">
					{{'附件信息 （'+quickSignInfo.files.length+'）'}}
				</div>
				<div class="all_details_content_card margin_top_2">
					<div class="files" v-for="(file,index) in quickSignInfo.files" :key="index">
						<div class="display_flex">
							<span class="display_inline_block display_flex" style="width: 1rem;line-height: 1rem;">
								<van-icon name="description" size="16" color="#666" />
							</span>
							<span class="display_inline_block text12 textcolor333" style="flex: 1;margin-left: .2rem;"
								@click="downFileClick(file)">{{file.fileName}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Icon
	} from 'vant';
	import {
		getDeviceType,
		fromateDownloadPath,
		openFile
	} from '../../utils/nativeOtherOperate.js'
	export default {
		name: 'quicksigndetails',
		components: {
			[Icon.name]: Icon,
		},
		data() {
			return {
				//速签信息是否隐藏
				//contractHidden: true,
				//速签信息
				quickSignInfo: null,
			}
		},
		methods: {
			//获取速签详情
			getContractDetails(contractId) {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/quick/api/getQuickDetail?contractId=" + contractId).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						//res.data.quickSigners[0].actStatus = 1
						this.quickSignInfo = res.data
					} else {
						this.$Toast(res.message || res.messageDetail || '获取合同详情失败！')
					}
				}).catch(err => {
					this.$store.dispatch(this.$LoadShow, false)
					console.log('getContractDetail', err)
					this.$Toast('获取合同详情失败！')
				});
			},
			downFileClick(doc) {
				const url = window.location.origin + process.env.VUE_APP_API_BASE_URL_MSIGN +
					'/file/api/downloadActFile?fileId=' +
					doc.fileId + '&resName=' + encodeURIComponent(doc.fileName)
				const header = 'Bearer ' + window.localStorage.getItem("Identity_Token")
				let that = this
				switch (getDeviceType()) {
					case 'android':
					case 'ios':
						console.log('downFileClick-url-=', url, window.localStorage.getItem(
							"Identity_Token"))
						let time = Date.now()
						let fileName = '_downloads/document_' + time + '.pdf'
						let aFileName = fromateDownloadPath('downloads/document_' + time + '.pdf')
						this.$store.dispatch(this.$LoadShow, true)
						this.$store.dispatch(this.$LoadText, '下载中...')
						let task = plus.downloader.createDownload(url, {
							filename: fileName,
						}, function(d, status) {
							console.log('-downFileClick-=', d, status)
							that.$store.dispatch(that.$LoadShow, false)
							that.$store.dispatch(that.$LoadText, '加载中...')
							if (status === 200) {
								//console.log('aFileName--=', aFileName)
								if (openFile(aFileName)) {
									that.$Toast('文件打开失败！')
								}else{
									that.$Toast('文件打开失败！')
								}
							} else {
								that.$Toast('下载文件失败，请重试！')
							}
						})
						task.setRequestHeader('Authorization', header);
						task.start()
						break
					case 'harmony':
						this.$store.dispatch(this.$LoadShow, true)
						this.$store.dispatch(this.$LoadText, '下载中...')
						// const testheader = 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJHVU9GRUkiLCJjbGllbnRJZCI6IjAiLCJleHAiOjE3NTM3NjU3ODUsImlhdCI6MTc1MzY5Mzc4NSwidXNlcm5hbWUiOiJHVU9GRUkifQ.SCg8pMcA5_oWZi6MOOudAM-3SGgWexunoJS0t1_yk8JFGX7A_uyZ8-yCGMAT9us99cg0jyJz9aNJTeEN8UmKpg'
						// const testurl = 'https://esign.sinopec.com/sign/file/api/downloadActFile?fileId=obs$b01$d01$64ad3414-5df7-437e-acb5-30504ce19619$pdf&resName=%E6%B5%8B%E8%AF%95%E6%8E%A5%E6%94%B6%E9%82%AE%E4%BB%B6%E5%92%8C%E7%9F%AD%E4%BF%A1'
						harmonyEsign.downFileToSanBox(header, url)
							.then(res => {
								console.log('downFileToSanBox-=', res)
								that.$store.dispatch(that.$LoadShow, false)
								that.$store.dispatch(that.$LoadText, '加载中...')
								if (res) {
									harmonyEsign.openFile(res).then(rel => {
										console.log('openFile-=', rel)
									}).catch(err => {
										console.log('openFile-err-=', err)
										that.$Toast('文件打开失败！')
									})
								} else {
									that.$Toast('下载文件失败，请重试！')
								}
							}).catch(err => {
								console.log('downFileToSanBox-err-=', err)
								that.$store.dispatch(that.$LoadShow, false)
								that.$store.dispatch(that.$LoadText, '加载中...')
								that.$Toast('下载文件失败，请重试！')
							})
						break;
				}
			},
			//初始化
			init() {
				const contractId = this.$route.query.contractId
				this.getContractDetails(contractId)
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.file {
		width: 100%;
		height: 2rem;
		border: 1px solid #ccc;
		border-radius: 0.1rem;
		display: flex;
		padding: 0 .5rem;
	}

	.corps {
		padding: .5rem;
		background-color: #f2f2f2;
		border-radius: .1rem;
		margin-bottom: 1rem;
	}

	.corps:last-child {
		margin-bottom: 0;
	}

	.files {
		padding: .5rem;
		background-color: #f2f2f2;
		border-radius: .1rem;
		margin-bottom: .5rem;
	}

	.files:last-child {
		margin-bottom: 0;
	}

	.corpsSelected {
		background-color: #81d3f825;
		border: 1px solid #02a7f0;
	}

	// 上链完成
	.uploadCompleted {
		background-color: #d7d7d7;
		border-radius: .1rem;
	}
</style>